var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93834 11.9948C4.71332 13.5459 5.00451 15.1279 5.76707 16.4972C6.52963 17.8666 7.72124 18.9472 9.15836 19.5726C10.5955 20.1981 12.1984 20.3337 13.7201 19.9586C15.2419 19.5834 16.5981 18.7184 17.5799 17.4966C18.5616 16.2749 19.1145 14.7642 19.1532 13.1974C19.192 11.6305 18.7145 10.0944 17.7943 8.82562C16.8742 7.55684 15.5624 6.62578 14.061 6.17588C12.5597 5.72597 10.952 5.78217 9.48574 6.33581M11.0015 3.91053L8.98048 5.9316L11.0015 7.95267",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.20ed08da82dc34a07c7f94845cb45007.svg";
export { ForwardRef as ReactComponent };